import React from 'react'
import { LeaderData } from '../../../../Api'
import { PlayerRow } from './PlayerRow'
import { Head2 } from '../../../../Components/Typography/Text.styles'
import { colors } from '../../../../Components/consts'
import { playersToWatchList } from '../../../../Constant/player'

type TeamLeadersProps = {
  teamLeaders: LeaderData[]
  awayId: string
  homeId: string
}

export const PlayersToWatch: React.FC<React.PropsWithChildren<TeamLeadersProps>> = ({
  teamLeaders,
  awayId,
  homeId,
}) => {
  return (
    <>
      {playersToWatchList.length > 0 && (
        <>
          <Head2 textColor={colors.white} justify="center">
            Stat Leaders
          </Head2>
          {playersToWatchList.map((stat) => (
            <PlayerRow
              key={stat}
              teamLeaders={teamLeaders}
              stat={stat}
              awayId={awayId}
              homeId={homeId}
            />
          ))}
        </>
      )}
    </>
  )
}
